export const iconFontAwesomeScienceCapsules = (
	<i className="fa-solid fa-capsules"></i>
);
